function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "model");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 770.56 317.65"
  }, props), _ref, React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M671.76,140.13v51.94c0,8.39-5.29,15.86-33,21.77S447.8,250.7,369,264.7,254.4,290.36,226.17,290.59s-44.95-4.12-56.3-11.27-49.61-35.77-56.46-40.13-6.33-8.79-6.33-8.79V137.67C40.75,156.78,0,182.71,0,211.27,0,270,172.5,317.65,385.28,317.65S770.56,270,770.56,211.27C770.56,183.92,733.18,159,671.76,140.13Z",
    style: {
      "fill": "#ff977b"
    }
  }), React.createElement("path", {
    d: "M160.62,164.85c29.39,21.93,62.75,17.73,99.61,11.66,30.24-5,256-48.35,349.3-66.36h0L509,37.76V32l-13.81,2.59,13,50.37,21.46,15.59-52.84,10.08h0l-41.48,7.91-.81.15-1,.2-.82.16-1,.2-.81.15-78.44,15-.81.16-1,.2-.82.15-1,.2-.81.16-75.64,14.42-3.4-2.45-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.33-1-1.06-.76-1.44-1-23.16-16.74,18-3.43-6-23.32c-50.28,9.58-89.19,17-98.16,18.82C104.39,109.21,107.08,121,107.08,121,107.89,130.48,131.22,142.92,160.62,164.85Zm32.66-52.38c15.84,0,28.69,4.76,28.69,10.62v14.35c0,5.86-12.85,10.61-28.69,10.61s-28.7-4.75-28.7-10.61V123.09C164.58,117.23,177.43,112.47,193.28,112.47Z",
    style: {
      "fill": "#ffa894"
    }
  }), React.createElement("path", {
    d: "M615.59,109c17.14-3.31,28.87-5.59,32.68-6.34,23.64-4.67,23.49-18.2,23.49-18.2s.93-3.73-13.69-13.69S636.61,52.4,610.79,37.47,566,21.61,529.92,28.14c-3.86.7-11.09,2-21,3.89Z",
    style: {
      "fill": "#ffa894"
    }
  }), React.createElement("path", {
    d: "M107.08,230.4s-.51,4.44,6.33,8.79,45.11,33,56.46,40.13,28.07,11.51,56.3,11.27S290.09,278.69,369,264.7s242.15-44.95,269.84-50.86,33-13.38,33-21.77V84.44s.15,13.53-23.49,18.2c-3.81.75-15.54,3-32.68,6.34h0l.29,53.38-6.35,1.38V110.15c-93.25,18-319.06,61.39-349.3,66.36-36.86,6.07-70.22,10.27-99.61-11.66s-52.73-34.37-53.54-43.9V230.4ZM585,206.84l-330,61.75V198l330-63.46Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("polygon", {
    points: "254.94 268.59 584.97 206.84 584.97 134.52 254.94 197.98 254.94 268.59",
    style: {
      "fill": "#ffa894"
    }
  }), React.createElement("polygon", {
    points: "609.53 110.15 609.53 110.15 609.53 163.74 615.88 162.36 615.59 108.98 615.59 108.98 508.95 32.03 508.95 32.03 508.95 32.03 508.95 37.76 609.53 110.15",
    style: {
      "fill": "#e26d4d"
    }
  }), React.createElement("polygon", {
    points: "237.14 107.99 219.17 111.42 242.33 128.16 237.14 107.99",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("polygon", {
    points: "476.73 110.66 476.73 110.66 529.57 100.58 508.11 84.99 512.94 103.75 476.73 110.66",
    style: {
      "fill": "#e26d4d"
    }
  }), React.createElement("path", {
    d: "M164.58,137.44c0,5.86,12.85,10.61,28.7,10.61S222,143.3,222,137.44V123.09c0,5.86-12.85,10.61-28.69,10.61s-28.7-4.75-28.7-10.61Z",
    style: {
      "fill": "#e26d4d"
    }
  }), React.createElement("ellipse", {
    cx: 193.28,
    cy: 123.09,
    rx: 28.7,
    ry: 10.61,
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M391.27,23.15c-.78-4.84,2-9.29,6.47-10.2l-.77.15c-4.27.84-7,4.86-6.6,9.4C390.68,22.7,391,22.92,391.27,23.15Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M400.08,14.51l-.76.15c-4.28.84-7,4.86-6.61,9.4a9.44,9.44,0,0,1,.91.65C392.84,19.86,395.58,15.42,400.08,14.51Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M402.43,16.06l-.77.15c-4.27.84-7,4.86-6.6,9.4.31.2.61.42.91.65C395.18,21.42,397.93,17,402.43,16.06Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M404.77,17.62l-.76.15c-4.28.84-7,4.86-6.61,9.4a8.35,8.35,0,0,1,.91.65C397.53,23,400.27,18.53,404.77,17.62Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M407.12,19.17l-.77.15c-4.27.84-7,4.86-6.6,9.4.31.2.62.42.91.65C399.88,24.53,402.62,20.08,407.12,19.17Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M409.47,20.72l-.77.15c-4.28.84-7,4.87-6.6,9.41a9.32,9.32,0,0,1,.9.65C402.22,26.08,405,21.64,409.47,20.72Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M411.81,22.28l-.76.15c-4.28.84-7,4.86-6.61,9.4a9.44,9.44,0,0,1,.91.65C404.57,27.63,407.31,23.19,411.81,22.28Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M413.39,24c-4.45.88-7.2,5.21-6.54,10a10.91,10.91,0,0,1,1.27,1.93L407.9,35c-1.34-5.21,1.46-10.2,6.26-11.18Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M410.24,36.56c-1.34-5.21,1.46-10.2,6.26-11.17l-.76.15c-4.83.95-7.66,5.95-6.31,11.18l21.3,82.71.81-.15Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M412.59,38.11c-1.34-5.21,1.46-10.19,6.26-11.17l-.77.15c-4.83.95-7.65,6-6.31,11.19l20.81,80.8.82-.16Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M414.93,39.67c-1.34-5.21,1.46-10.2,6.26-11.17l-.76.15c-4.83,1-7.66,6-6.31,11.18l20.32,78.89.81-.15Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M307.74,36.52c-.56-4.68,2.14-8.9,6.51-9.79l-.76.15c-4.16.82-6.82,4.64-6.63,9A10.72,10.72,0,0,1,307.74,36.52Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M316.6,28.29l-.77.15c-4.15.81-6.82,4.64-6.63,9a10.77,10.77,0,0,1,.89.61C309.52,33.39,312.23,29.17,316.6,28.29Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M318.94,29.84l-.76.15c-4.16.82-6.82,4.64-6.63,9a10.72,10.72,0,0,1,.88.62C311.87,35,314.57,30.73,318.94,29.84Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M321.29,31.4l-.77.15c-4.15.81-6.82,4.64-6.62,9a9.91,9.91,0,0,1,.88.61C314.21,36.5,316.92,32.28,321.29,31.4Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M323.63,33l-.76.15c-4.16.82-6.82,4.64-6.63,9a8.74,8.74,0,0,1,.88.62C316.56,38.06,319.26,33.84,323.63,33Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M326,34.51l-.77.15c-4.15.81-6.82,4.63-6.62,9,.3.19.59.4.88.62C318.9,39.61,321.61,35.39,326,34.51Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M328.32,36.06l-.76.15c-4.16.82-6.82,4.64-6.63,9a7.74,7.74,0,0,1,.88.62C321.25,41.16,324,37,328.32,36.06Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M329.91,37.77c-4.31.84-7,4.92-6.6,9.5a10.32,10.32,0,0,1,1.1,1.52h0c-1.34-5.21,1.46-10.2,6.26-11.18Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M326.76,50.34c-1.35-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83,1-7.65,6-6.31,11.18l21.83,84.76.81-.16Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M329.1,51.9c-1.34-5.21,1.46-10.2,6.26-11.18l-.76.15c-4.83,1-7.66,6-6.31,11.19l21.33,82.84.82-.15Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M331.45,53.45c-1.34-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83,1-7.65,6-6.31,11.18l20.85,80.94.81-.16Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M242.33,128.16l1.44,1-20-77.67c-1.34-5.22,1.48-10.23,6.31-11.18l.77-.15c-4.8,1-7.6,6-6.26,11.17L244.83,130l1.33,1-20-77.84c-1.35-5.23,1.48-10.24,6.31-11.19l.76-.15c-4.8,1-7.6,6-6.26,11.18l20.29,78.76,1.33,1-20.09-78c-1.34-5.22,1.48-10.23,6.31-11.18l.77-.15c-4.8,1-7.6,6-6.26,11.17l20.33,78.93,1.33,1L230.81,56.2C229.46,51,232.29,46,237.12,45l.77-.15c-4.8,1-7.61,6-6.27,11.17L252,135.14l1.33,1L233.16,57.75c-1.35-5.23,1.47-10.23,6.31-11.18l.76-.15c-4.8,1-7.6,6-6.26,11.17l20.42,79.28,1.33,1L235.5,59.31c-1.34-5.23,1.48-10.24,6.31-11.19l.77-.15c-4.8,1-7.61,6-6.26,11.17l20.46,79.45,1.33,1-20.26-78.7c-1.35-5.23,1.48-10.23,6.31-11.18l.76-.15c-4.8,1-7.6,6-6.26,11.17l20.51,79.62,1.33,1L240.19,62.42c-1.34-5.23,1.48-10.24,6.31-11.19l.77-.15c-4.8,1-7.6,6-6.26,11.17l20.55,79.8,1.33,1L242.54,64c-1.35-5.23,1.48-10.24,6.31-11.18l.76-.15c-4.8,1-7.6,6-6.26,11.17l20.6,80,1.33,1-20.4-79.22c-1.34-5.22,1.48-10.23,6.31-11.18l.77-.15c-4.8,1-7.6,6-6.26,11.17l20.64,80.14,1.33,1L247.23,67.08c-1.35-5.23,1.48-10.24,6.31-11.19l.77-.15c-4.8,1-7.61,6-6.27,11.18l20.69,80.31,3.4,2.45,75.64-14.42L325.94,50.5c-1.34-5.22,1.48-10.23,6.31-11.18l.77-.15c-4.8,1-7.61,6-6.26,11.17l21.82,84.76,1-.2L328.29,52.06c-1.35-5.23,1.48-10.24,6.31-11.19l.76-.15c-4.8,1-7.6,6-6.26,11.18l21.34,82.85,1-.2L330.63,53.61c-1.34-5.22,1.48-10.23,6.31-11.18l.77-.15c-4.8,1-7.6,6-6.26,11.17l20.84,80.94,78.44-15-21.3-82.71c-1.35-5.23,1.48-10.23,6.31-11.18l.76-.15c-4.8,1-7.6,6-6.26,11.17l21.3,82.72,1-.2-20.81-80.8c-1.34-5.23,1.48-10.24,6.31-11.19l.77-.15c-4.8,1-7.6,6-6.26,11.17l20.81,80.81,1-.2L414.12,39.83c-1.35-5.23,1.48-10.23,6.31-11.18l.76-.15c-4.8,1-7.6,6-6.26,11.17l20.32,78.9,41.48-7.91,36.21-6.91L508.11,85l-13-50.37-2.63-10.2a10.73,10.73,0,0,0-5.68-7,10.28,10.28,0,0,0-2.35-1.55,10.33,10.33,0,0,0-2.35-1.56,10,10,0,0,0-2.34-1.55,10.33,10.33,0,0,0-2.35-1.56,10,10,0,0,0-2.34-1.55,10.33,10.33,0,0,0-2.35-1.56,10.23,10.23,0,0,0-2.34-1.55A10.67,10.67,0,0,0,468.06,5a10.28,10.28,0,0,0-2.35-1.55,10,10,0,0,0-3.84-2.12A8.94,8.94,0,0,0,455.59.16L395.51,12c-4.35.86-7.07,5-6.58,9.64a10.14,10.14,0,0,0-2-1.27,10.28,10.28,0,0,0-2.35-1.55,10.06,10.06,0,0,0-2.34-1.56,10.07,10.07,0,0,0-3.85-2.12,8.93,8.93,0,0,0-6.28-1.16L312,25.74c-4.22.83-6.91,4.76-6.62,9.23a10,10,0,0,0-1.88-1.17,10.33,10.33,0,0,0-2.35-1.56,10.28,10.28,0,0,0-2.35-1.55A9.9,9.9,0,0,0,295,28.57a9,9,0,0,0-6.28-1.17L228.62,39.21c-4.83.95-7.66,6-6.31,11.18l8.82,34.28,6,23.32Zm73.5-99.72.77-.15c-4.37.88-7.08,5.1-6.51,9.78a10.77,10.77,0,0,0-.89-.61C309,33.08,311.68,29.25,315.83,28.44Zm83.49-13.78.76-.15c-4.5.91-7.24,5.35-6.46,10.2a9.44,9.44,0,0,0-.91-.65C392.34,19.52,395,15.5,399.32,14.66ZM318.18,30l.76-.15c-4.37.89-7.07,5.11-6.51,9.79a10.72,10.72,0,0,0-.88-.62C311.36,34.63,314,30.81,318.18,30Zm83.48-13.78.77-.15c-4.5.91-7.25,5.36-6.46,10.2-.3-.23-.6-.45-.91-.65C394.69,21.07,397.39,17.05,401.66,16.21ZM320.52,31.55l.77-.15c-4.37.88-7.08,5.1-6.51,9.78a9.91,9.91,0,0,0-.88-.61C313.7,36.19,316.37,32.36,320.52,31.55ZM404,17.77l.76-.15c-4.5.91-7.24,5.35-6.46,10.2a8.35,8.35,0,0,0-.91-.65C397,22.63,399.73,18.61,404,17.77ZM316.24,42.12c-.19-4.38,2.47-8.2,6.63-9l.76-.15c-4.37.89-7.07,5.11-6.51,9.79A8.74,8.74,0,0,0,316.24,42.12Zm83.51-13.4c-.37-4.54,2.33-8.56,6.6-9.4l.77-.15c-4.5.91-7.24,5.36-6.46,10.2C400.37,29.14,400.06,28.92,399.75,28.72Zm-81.16,15c-.2-4.38,2.47-8.2,6.62-9l.77-.15c-4.37.88-7.08,5.1-6.51,9.78C319.18,44.07,318.89,43.86,318.59,43.67ZM402.1,30.28c-.37-4.54,2.32-8.57,6.6-9.41l.77-.15c-4.5.92-7.25,5.36-6.47,10.21A9.32,9.32,0,0,0,402.1,30.28ZM321.81,45.85a7.74,7.74,0,0,0-.88-.62c-.19-4.38,2.47-8.2,6.63-9l.76-.15C324,37,321.25,41.16,321.81,45.85Zm83.54-13.37a9.44,9.44,0,0,0-.91-.65c-.37-4.54,2.33-8.56,6.61-9.4l.76-.15C407.31,23.19,404.57,27.63,405.35,32.48ZM324.41,48.79h0a10.32,10.32,0,0,0-1.1-1.52c-.42-4.58,2.29-8.66,6.6-9.5l.76-.16C325.87,38.59,323.07,43.58,324.41,48.79ZM407.9,35l.22.88A10.91,10.91,0,0,0,406.85,34c-.66-4.77,2.09-9.1,6.54-10l.77-.15C409.36,24.81,406.56,29.8,407.9,35ZM397,13.1l.77-.15c-4.5.91-7.25,5.36-6.47,10.2-.29-.23-.59-.45-.9-.65C390,18,392.7,13.94,397,13.1ZM313.49,26.88l.76-.15c-4.37.89-7.07,5.11-6.51,9.79a10.72,10.72,0,0,0-.88-.62C306.67,31.52,309.33,27.7,313.49,26.88Z",
    style: {
      "fill": "#ffd4cf"
    }
  }), React.createElement("path", {
    d: "M224.59,51.37c-1.34-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83.95-7.65,6-6.31,11.18l20,77.67,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M226.93,52.93c-1.34-5.21,1.46-10.2,6.26-11.18l-.76.15c-4.83,1-7.66,6-6.31,11.19l20,77.84,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M229.28,54.48c-1.34-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83.95-7.65,6-6.31,11.18l20.09,78,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M231.62,56c-1.34-5.21,1.47-10.19,6.27-11.17l-.77.15c-4.83,1-7.66,6-6.31,11.19l20.13,78.18,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M234,57.59c-1.34-5.21,1.46-10.2,6.26-11.17l-.76.15c-4.84,1-7.66,6-6.31,11.18l20.17,78.36,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M236.32,59.14C235,53.93,237.78,49,242.58,48l-.77.15c-4.83,1-7.65,6-6.31,11.19l20.22,78.52,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M238.66,60.7c-1.34-5.21,1.46-10.2,6.26-11.17l-.76.15c-4.83,1-7.66,6-6.31,11.18l20.26,78.7,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M241,62.25c-1.34-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83,1-7.65,6-6.31,11.19l20.31,78.87,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M243.35,63.81c-1.34-5.21,1.46-10.2,6.26-11.17l-.76.15c-4.83.94-7.66,6-6.31,11.18l20.35,79,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M245.7,65.36c-1.34-5.21,1.46-10.2,6.26-11.17l-.77.15c-4.83.95-7.65,6-6.31,11.18l20.4,79.22,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  }), React.createElement("path", {
    d: "M248,66.92c-1.34-5.21,1.47-10.2,6.27-11.18l-.77.15c-4.83,1-7.66,6-6.31,11.19l20.44,79.39,1.06.76Z",
    style: {
      "fill": "#ff8257"
    }
  })))));
};

export default __webpack_public_path__ + "static/media/model.bcca4c7b.svg";
export { SvgComponent as ReactComponent };